import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { otpBorrowerMe } from "../../service/otpApi";

function getBorrowerToken() {
  return sessionStorage.getItem("borrowerToken") || "";
}

/**
 * Protect borrower routes:
 * - requires sessionStorage borrowerToken
 * - optionally validates token by calling /otp/borrower/me (recommended)
 */
export default function BorrowerProtectedRoute({ children }) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const run = async () => {
      const token = getBorrowerToken();

      if (!token) {
        setOk(false);
        setChecking(false);
        return;
      }

      try {
        // ✅ validate token server-side (prevents stale/expired tokens)
        await otpBorrowerMe();
        setOk(true);
      } catch (err) {
        // token invalid/expired
        sessionStorage.removeItem("borrowerToken");
        sessionStorage.removeItem("borrowerUser");
        setOk(false);
      } finally {
        setChecking(false);
      }
    };

    run();
  }, []);

  if (checking) {
    return (
      <Box sx={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!ok) {
    return <Navigate to="/borrower/login" replace state={{ from: location }} />;
  }

  return children;
}
